import * as Types from '../action-types';
import update from 'immutability-helper';
import Inventory from '../../components/models/inventory';

const initialState = new Inventory();

let inventoryReducer = function(state = initialState, action) {
    switch (action.type) {
        case Types.SET_INVENTORY:
            return update(state, {
                inventory: {
                    $set: action.response
                }
            });
        case Types.SET_MODEL_OBJECT:
            return update(state, {
                $set: action.inventoryObject
            });
        case Types.SET_INVENTORYDATA:
            return update(state, {
                inventoryData: {
                    $set: action.inventoryData
                }
            });
        case Types.INVENTORY_SAVE_SUCCESS:
        case Types.INVENTORY_GET_SUCCESS:
            return update(state, {
                $set: action.response
            });
        case Types.INVENTORY_CHECK_SUCCESS:
            return update(state, {
                existingInventory: { $set: action.response }
            });
        case Types.INVENTORY_RESET_PAGE_ON_ADD:
            return update(state, {
                $set: action.inventory,
                inventoryData: {
                    $set: action.inventoryData
                }
            });
        case Types.INVENTORY_SEARCH_SUCCESS:
            if (action.response.inventory != null && action.response.inventory.length > 0) {
                return update(state, {
                    inventorySearchData: { $set: action.response.inventory },
                    pageNumber: { $set: action.response.pageNumber },
                    pageSize: { $set: action.response.pageSize },
                    totalItemCount: { $set: action.response.totalItemCount }
                });
            } else {
                return update(state, {
                    inventorySearchData: { $set: [] }
                });
            }
        default:
            return state;
    }
};

export default inventoryReducer;
